import '../images/no-image-50.png';
import '../images/no-image-70.png';
import '../images/no-image-280.png';

import $ from 'jquery';

/**
 * replace the image src with a fallback on error
 */
$.fn.extend({
    imageFallback: function () {

        return this.each((index, element) => {
            const image = $(element);

            image.on('error', function () {

                // make sure we do not end up in an infinite loop
                if (image.data('fallback-src') !== '' && image.attr('src') !== image.data('fallback-src')) {
                    image.attr('src', image.data('fallback-src'));
                }

                if (image.data('fallback-alt') !== '') {
                    image.attr('alt', image.data('fallback-alt'));
                }

                // if it's part of a lightbox remove zoom
                /*if (image.parent('[rel^="lightbox"]').length > 0) {

                    // check if it's a gallery
                    const isGallery = (image.parent('[rel^="lightbox[gallery]"]').length > 0);

                    // remove zoom stuff
                    image
                        .parent()
                        .removeAttr('rel')
                        .removeAttr('href');

                    // if it's not the first image of the gallery, remove the whole gallery list item
                    const li = image
                            .parent()
                            .parent('li');
                    if (isGallery && li.index() > 0) {
                        li.remove();
                    }
                }*/
            });
        });
    }
});


// WEBPACK FOOTER //
// ./jquery/jquery.imageFallback.js